import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings';
import {ISettingsParams} from '../../domain/utils/settings.utils';

export const settingsParams = {
  CART_TITLE: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: Function}) => t('sideCart.title.label'),
    inheritFromAppScope: true,
  },
  CART_EMPTY_CART: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: Function}) => t('sideCart.cartEmpty.emptyState'),
    inheritFromAppScope: true,
  },
  CART_BUTTON_TEXT: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: Function}) => t('sideCart.goToCheckout.cta'),
    inheritFromAppScope: true,
  },
};
export default createSettingsParams<ISettingsParams<typeof settingsParams>>(settingsParams);
